export class FiltroControleDeAcesso {
  dataInicio: Date;
  dataFim: Date;
  id_grupo: number;
}
